/** Default product name shown in UI and editable email invite drafts */
export const PORTAL_NAME = 'Paytiemp Hiring Portal';

export const INVITE_EMAIL_SUBJECT = `Welcome to ${PORTAL_NAME} - Your Login Credentials`;

export const INVITE_EMAIL_BODY = `Dear [Name],

Welcome to our ${PORTAL_NAME}! Your account has been created.

Login Credentials:
Email: [Email]
Password: [Password]

Application URL: [ApplicationURL]

Please log in using the credentials above and change your password after first login.

Best regards,
Recruitment Team`;
